import theme from '@styles/theme';
export default {
  section: {
    display: 'flex',
    justifyContent: 'center',
    overflowX: 'hidden',
    padding: ['0 16px', '0 16px', '0 24px', '0 24px', '0 40px']
  },
  instructionListContainer: {
    width: '100%',
    maxWidth: '1530px',
    height: 'auto',
    margin: 'auto',
    boxSizing: 'border-box',
    marginBottom: '60px',
    h2: {
      marginBottom: '60px'
    }
  },
  instructionListContent: (paddings: boolean) => ({
    padding: paddings ? '40px 0 0' : 0,
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: '100%',
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: theme.fontSizes.smallText,
    color: theme.rawColors.neutralBlack,
    borderBottom: `1px solid ${theme.rawColors.lightGrey700}`,
    '&:last-of-type': {
      mb: ['48px', '48px', '64px', '64px', '116px']
    }
  }),
  instructionListContainerContent: {
    paddingBottom: ['44px', '44px', '56px', '64px'],
    paddingTop: ['4px', '4px', '12px', '20px'],
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: theme.fontSizes.text,
    lineHeight: '175%',
    color: theme.rawColors.darkGrey700,
    strong: {
      fontFamily: theme.fonts.uniformMedium,
      fontWeight: 500,
      mb: '8px',
      display: 'inline-block'
    },
    'p:empty:before': {
      content: '" "',
      whiteSpace: 'pre'
    },
    'ul br, ol br': {
      display: 'none'
    },
    ol: {
      listStyle: 'number',
      pl: '16px',
      li: {
        mb: '4px'
      }
    }
  },
  list: {
    listStyle: 'none',
    display: ['block', 'flex'],
    flexWrap: 'wrap',
    flexDirection: 'row'
  },
  deliveryList: {
    listStyle: 'none',
    display: ['block', 'flex'],
    flexWrap: 'wrap',
    flexDirection: 'row'
  },
  attributeItem: {
    listStyle: 'none !important',
    display: 'flex !important',
    alignItems: 'center',
    padding: '0 0 24px !important',
    width: ['100%', '50%'],
    ':before': {
      display: 'none'
    }
  },
  pictureItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '0 0 24px !important',
    width: ['100%', '50%']
  },
  attributeText: {
    fontSize: theme.fontSizes.text,
    fontWeight: theme.fontWeights.normal,
    fontFamily: theme.fonts.uniform,
    color: theme.rawColors.darkGrey700,
    lineHeight: '22px',
    paddingLeft: '16px'
  },
  pictureText: {
    fontSize: theme.fontSizes.text,
    fontWeight: theme.fontWeights.normal,
    fontFamily: theme.fonts.uniform,
    color: theme.rawColors.darkGrey700,
    lineHeight: '22px',
    width: '100%'
  },
  instructionListDelivery: {
    display: ['block', 'block', 'flex']
  },
  videoStyles: {
    maxWidth: '100%',
    width: '100%',
    height: ['190px', '404px', '337px'],
    position: 'relative',
    margin: '24px auto',
    marginLeft: 0
  },
  descriptionContainer: {
    width: '100%'
  },
  descriptionContainerInner: {
    display: ['block', 'block', 'block', 'flex']
  },
  descriptionDetails: {
    maxWidth: ['100%', '100%', '100%', '100%', '50%']
  },
  technicalContainer: {
    display: ['block', 'block', 'block', 'block', 'flex']
  },
  technicalText: {
    fontSize: theme.fontSizes.text,
    fontWeight: theme.fontWeights.normal,
    fontFamily: theme.fonts.uniform,
    color: theme.rawColors.darkGrey700,
    lineHeight: '175%',
    '&:last-of-type': {
      marginBottom: ['24px', '24px', '24px', '24p', '20']
    }
  },
  technicalDimensionName: {
    textTransform: 'capitalize'
  },
  downloadLinkList: {
    listStyle: 'none'
  },
  downloadLink: {
    display: ['block', 'block', 'block', 'flex'],
    fontSize: theme.fontSizes.text,
    fontWeight: theme.fontWeights.normal,
    fontFamily: theme.fonts.uniform,
    color: theme.rawColors.darkGrey700,
    lineHeight: '175%',
    marginBottom: ['24px', '24px', '24px', '24p', '20'],
    span: {
      marginRight: '8px'
    }
  }
};